import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface InvInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function InvInternalControls({ onBack, setActiveSection, controlsListSection }: InvInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Inventory"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}



